import React from "react";
import Heading from "../../components/common/Typography/Heading";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import {
  publicMainHeaderOffsetClass,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from "../Public/shared/publicLayoutSpec";

const LicensingDocs = () => {
  return (
    <div
      className={`tp-container-small mx-auto w-full min-h-screen text-offblack ${publicMainHeaderOffsetClass()}`}
    >
      <Heading variant={"h1"} className="flex justify-center text-center text-offblack">
        Licensing
      </Heading>
      <div
        className={`${PUBLIC_HEADING_TO_CONTENT_CLASS} grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6`}
      >
        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://ncc.abcb.gov.au/resources" target="_blank" rel="noopener noreferrer" className="text-offblack">
              NCC
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.abcb.gov.au/resources" target="_blank" rel="noopener noreferrer" className="text-offblack">
              ABCB
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.vba.vic.gov.au" target="_blank" rel="noopener noreferrer" className="text-offblack">
              VIC – VBA
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.fairtrading.nsw.gov.au/housing-and-property" target="_blank" rel="noopener noreferrer" className="text-offblack">
              NSW – Fair Trading
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.accesscanberra.act.gov.au/business-and-work/building-and-construction" target="_blank" rel="noopener noreferrer" className="text-offblack">
              ACT – BCA
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.qbcc.qld.gov.au" target="_blank" rel="noopener noreferrer" className="text-offblack">
              QLD – QBCC
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.wa.gov.au/organisation/department-of-energy-mines-industry-regulation-and-safety" target="_blank" rel="noopener noreferrer" className="text-offblack">
              WA – DMIRS
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.cbs.sa.gov.au/sections/Licences#building" target="_blank" rel="noopener noreferrer" className="text-offblack">
              SA – CBS
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://www.cbos.tas.gov.au" target="_blank" rel="noopener noreferrer" className="text-offblack">
              TAS – CBOS
            </a>
          </SecondaryHeading>
        </div>

        <div>
          <SecondaryHeading variant={"MainParagraphHeading"}>
            <a href="https://nt.gov.au/property" target="_blank" rel="noopener noreferrer" className="text-offblack">
              NT – DIPL
            </a>
          </SecondaryHeading>
        </div>
      </div>
    </div>
  );
};

export default LicensingDocs;
